import types from './types'

const updateSavedPublicCollegeSearch = (payload) => (dispatch) => {
  dispatch({
    type: types.UPDATE_SAVED_PUBLIC_COLLEGE_SEARCH,
    payload,
  })
  return Promise.resolve()
}

const clearSavedPublicCollegeSearch = () => (dispatch) => {
  dispatch({
    type: types.CLEAR_SAVED_PUBLIC_COLLEGE_SEARCH,
  })
  return Promise.resolve()
}

const actions = {
  updateSavedPublicCollegeSearch,
  clearSavedPublicCollegeSearch,
}

export default actions
